/**
 * PasswordField — text input with a show/hide toggle.
 *
 * The toggle is a small ghost button inside the input's trailing edge,
 * keyboard-accessible and announced to screen readers.
 */

import { forwardRef, useState, type InputHTMLAttributes } from "react";

type Props = InputHTMLAttributes<HTMLInputElement> & {
  id: string;
};

export const PasswordField = forwardRef<HTMLInputElement, Props>(function PasswordField(
  { id, ...rest },
  ref,
) {
  const [shown, setShown] = useState(false);
  return (
    <div className="pw-field">
      <input
        {...rest}
        id={id}
        ref={ref}
        type={shown ? "text" : "password"}
        autoComplete={rest.autoComplete ?? "current-password"}
      />
      <button
        type="button"
        className="pw-toggle"
        onClick={() => setShown((v) => !v)}
        aria-pressed={shown}
        aria-controls={id}
        title={shown ? "Hide password" : "Show password"}
      >
        {shown ? "Hide" : "Show"}
      </button>
    </div>
  );
});
